import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { unassignManyConsistencyCheckRanTemplate } from '@api/consistencyCheck';

import { TConsistencyCheckRanGetAvailableTemplatesDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { IOnSuccess } from '@interfaces/common/handlers';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_TABLE, CONSISTENCY_RAN_UNASSIGN_MANY_TEMPLATE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConsistencyCheckRanUnassignManyTemplate {
	unassignManyTemplate: UseMutateFunction<any, any, TConsistencyCheckRanGetAvailableTemplatesDTO, any>;
	isLoadingUnassignManyTemplate: boolean;
}

export const useMutateConsistencyCheckRanUnassignManyTemplate = ({
	onSuccess,
}: IOnSuccess): IUseMutateConsistencyCheckRanUnassignManyTemplate => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<TConsistencyCheckRanGetAvailableTemplatesDTO>({
		mutationKey: [CONSISTENCY_RAN_UNASSIGN_MANY_TEMPLATE],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: unassignManyConsistencyCheckRanTemplate,
		onSuccess: () => {
			onSuccess?.();

			dispatch(setSnackbar({
				message: responseMessages.unassignManyConsistencyCheckRanTemplate,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CONSISTENCY_RAN_TABLE])];
		},
	});

	return {
		unassignManyTemplate: mutate,
		isLoadingUnassignManyTemplate: isLoading,
	};
};
